"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Graph = _interopRequireDefault(require("./components/01_Graph"));

/**
 * A autoscaling pie chart to show single or multi data.
 *
 * Uses Chart.js to create a opinionated bar chart that can handle displaying large amount of data.
 *
 * To learn more about how to use this component, see examples within Storybook.
 *
 * @param {object} props React components passed in props
 * @param {object} [props.dataset] The data to display
 * @param {array} [props.dataset.labels] Labels to show across X axis
 * @param {object[]} [props.dataset.datasets] Datasets to show per label
 * @param {number[]} [props.dataset.datasets.data] Array of number values aligning with label index
 * @param {boolean} [props.disableAllAnimation] Disables animation
 * @param {string[]} [props.colorScale] Array of color strings
 * @param {object} [props.graphOptions] Can add / override options passed into chart.js
 * @param {boolean} [props.showDataLabels] Shows values on bars
 * @param {boolean} [props.hideTooltip] Disables tooltip while hovering bars
 */
var PieChartScalable = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var dataset = _ref.dataset,
      colorScale = _ref.colorScale,
      disableAllAnimation = _ref.disableAllAnimation;
  return /*#__PURE__*/_react["default"].createElement(_Graph["default"], {
    dataset: dataset,
    colorScale: colorScale,
    disableAllAnimation: disableAllAnimation
  });
}, []);

var _default = PieChartScalable;
exports["default"] = _default;